import { BaseDto } from './base.dto';
import { IsDefined, IsNotEmpty, IsString, Length, Matches } from 'class-validator';
import { validationPatterns } from '@up/data';

export class OrderReceiptPhotoTypeDto extends BaseDto {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(0, 45)
  @Matches(validationPatterns.nameValidation)
  name: string;
}